// import React, { useState } from 'react'
// import { useSelector } from 'react-redux';
// import { useTheme } from '../../../utils/themeToggle/theme';
// import { Modal, Checkbox, message } from "antd";
// import axiosInstance from "../../../utils/axiosInstance"; // path adjust karo agar alag hai
// import { ReplyAllOutlineIcon, ReplyOutlineIcon } from '../../../components/icons/ReplyOutlineIcons';
// import { limitWords } from '../../../utils/utils';
// import PdfIcon from '../../../components/icons/PdfIcon';
// import DocIcon from '../../../components/icons/DocIcon';
// import UnknownIcon from '../../../components/icons/UnknownIcon';


// const FileGrid = ({ files, title, user_id, contract, handleSetMainFile, handlePreview, selectedIndex, setSelectedIndex }) => {
//     if (!files?.length) return null;

//     return (
//         <div className="mt-2">
//             <strong className="block mb-1">{title}:</strong>
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
//                 {files.map((file, idx) => {
//                     const isPdf = file.file_url?.toLowerCase().endsWith(".pdf");
//                     const isDoc = file.file_url?.toLowerCase().endsWith(".docx") || file.file_url?.toLowerCase().endsWith(".doc");

//                     return (
//                         <div key={idx} className="flex items-center gap-1 border rounded-md p-1 bg-white dark:bg-[#0E0E2C] shadow-sm w-full cursor-pointer">

//                             {contract.editable_user === user_id && (
//                                 <Checkbox
//                                     checked={selectedIndex === idx}
//                                     onChange={(e) => {
//                                         const checked = e.target.checked;
//                                         setSelectedIndex(checked ? idx : null);

//                                         Modal.confirm({
//                                             title: "Make this the main agreement file?",
//                                             content: "Are you sure you want to set this file as the main agreement?",
//                                             okText: "Yes",
//                                             cancelText: "No",
//                                             onOk: async () => {
//                                                 try {
//                                                     await handleSetMainFile(file.file_url);
//                                                 } finally {
//                                                     setSelectedIndex(null);
//                                                 }
//                                             },
//                                             onCancel: () => setSelectedIndex(null),
//                                         });
//                                     }}
//                                 />
//                             )}

//                             <div className="w-10 h-12 flex items-center justify-center" onClick={() => handlePreview(file.file_url)}>
//                                 {isPdf ? (
//                                     <PdfIcon />
//                                 ) : isDoc ? (
//                                     <DocIcon />
//                                 ) : (
//                                     <UnknownIcon />
//                                 )}
//                             </div>

//                             <div className="flex flex-col max-w-[170px]">
//                                 <span className="text-[11px] font-medium text-gray-800 dark:text-gray-200 break-words">
//                                     {limitWords(file.file_name, 20)}
//                                 </span>
//                                 <span className="text-[10px] text-gray-500 truncate">
//                                     {new Date(file.uploaded_at).toLocaleString()}
//                                 </span>
//                             </div>

//                         </div>
//                     );
//                 })}
//             </div>
//         </div>
//     );
// };

// const EmailThreadItems = ({ item, onReply, id, contract, fetchContracts }) => {
//     const [previewFile, setPreviewFile] = useState(null);
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [selectedAgreementIndex, setSelectedAgreementIndex] = useState(null);
//     const [selectedAttachmentIndex, setSelectedAttachmentIndex] = useState(null);
//     const [selectedAdditionalIndex, setSelectedAdditionalIndex] = useState(null);
//     const [showFull, setShowFull] = useState(false);
//     const { darkMode } = useTheme();
//     const initials = item?.sender_email?.charAt(0).toUpperCase() || "U";
//     const bgColors = ["bg-green-600", "bg-amber-600", "bg-cyan-600", "bg-blue-600"];
//     const randomColor = bgColors[(item?.id ?? 0) % bgColors.length];
//     const comp_id = useSelector((store) => store.auth.userInfo.company_id);
//     const user_id = useSelector((store) => store.auth.userInfo.user_id);
//     const companyId = localStorage.getItem("companyId") || comp_id;

//     const handlePreview = (fileUrl) => {
//         setPreviewFile(fileUrl);
//         setIsModalOpen(true);
//     };

//     const handleSetMainFile = async (fileUrl) => {
//         try {
//             const payload = {
//                 company_id: companyId,
//                 file_url: fileUrl,
//             };
//             const res = await axiosInstance.post(
//                 `/agreements/${id}/set-main-file/`,
//                 payload
//             );
//             const msg = res.data.message || "File set as main agreement successfully!";
//             if (res.status === 200) {
//                 message.success(msg);
//             }
//             fetchContracts();
//         } catch (error) {
//             console.error(error);
//             const msg = error?.response?.data?.error || "Failed to set file as main agreement";
//             message.error(msg);
//         }
//     };

//     return (
//         <>
//             <div className="flex flex-col gap-1 py-3 border-b border-gray-200 dark:border-gray-700">
//                 <div className="flex justify-between items-start gap-2">
//                     <div className="flex gap-2">
//                         <div className={`w-8 h-8 rounded-full flex items-center justify-center text-white font-medium ${randomColor}`}>
//                             {initials}
//                         </div>
//                         <div>
//                             <div className="flex justify-between items-center gap-5">
//                                 <span className="text-sm font-semibold text-gray-800 dark:text-gray-200">{item.sender_email}</span>
//                                 <span className="text-[10px] text-gray-400">{item.timestamp ? new Date(item.timestamp).toLocaleString() : ""}</span>
//                                 <span className="text-xs text-gray-600 dark:text-gray-300">{item.direction}</span>
//                             </div>
//                             <div className="text-xs text-gray-500 dark:text-gray-400">
//                                 <div className="block"><strong>To:</strong> {item.receiver_emails?.to?.join(", ") || "-"}</div>
//                                 {item.receiver_emails?.cc?.length > 0 && (
//                                     <div className="block"><strong>CC:</strong> {item.receiver_emails.cc.join(", ")}</div>
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                     <div className="flex gap-2 text-xs">
//                         <button className="text-blue-500 hover:underline" onClick={() => onReply(item, "reply")}>
//                             <ReplyOutlineIcon />
//                         </button>
//                         <button className="text-blue-500 hover:underline" onClick={() => onReply(item, "replyAll")}>
//                             <ReplyAllOutlineIcon />
//                         </button>
//                     </div>
//                 </div>
//                 <div className="text-[12px] mt-2 leading-relaxed break-words dark:text-white text-black">
//                     <div
//                         className={`relative transition-all duration-300 ${showFull ? "line-clamp-none" : "line-clamp-2"
//                             }`}
//                         dangerouslySetInnerHTML={{ __html: item.body }}
//                     />

//                     {item.body && !showFull && (
//                         <span
//                             className="text-blue-500 cursor-pointer text-xs font-medium ml-1"
//                             onClick={() => setShowFull(true)}
//                         >
//                             ... Read more
//                         </span>
//                     )}
//                     {item.body && showFull && (
//                         <span
//                             className="text-blue-500 cursor-pointer text-xs font-medium ml-1"
//                             onClick={() => setShowFull(false)}
//                         >
//                             Read less
//                         </span>
//                     )}
//                 </div>


//                 <FileGrid
//                     files={item.agreement_file}
//                     title="Agreement File"
//                     user_id={user_id}
//                     contract={contract}
//                     handleSetMainFile={handleSetMainFile}
//                     handlePreview={handlePreview}
//                     selectedIndex={selectedAgreementIndex}
//                     setSelectedIndex={setSelectedAgreementIndex}
//                 />

//                 <FileGrid
//                     files={item.attachments}
//                     title="Attachments"
//                     user_id={user_id}
//                     contract={contract}
//                     handleSetMainFile={handleSetMainFile}
//                     handlePreview={handlePreview}
//                     selectedIndex={selectedAttachmentIndex}
//                     setSelectedIndex={setSelectedAttachmentIndex}
//                 />

//                 <FileGrid
//                     files={item.additional_attachments}
//                     title="Additional Attachments"
//                     user_id={user_id}
//                     contract={contract}
//                     handleSetMainFile={handleSetMainFile}
//                     handlePreview={handlePreview}
//                     selectedIndex={selectedAdditionalIndex}
//                     setSelectedIndex={setSelectedAdditionalIndex}
//                 />

//             </div>
//             <Modal
//                 open={isModalOpen}
//                 onCancel={() => setIsModalOpen(false)}
//                 width="90%"
//                 height="80%"
//                 footer={null}
//                 destroyOnClose={true}
//                 closeIcon={
//                     <div
//                         style={{
//                             backgroundColor: "red",
//                             borderRadius: "50%",
//                             width: 42,
//                             height: 22,
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                         }}
//                     >
//                         <span style={{ color: "#fff", fontSize: 14 }}>✕</span>
//                     </div>
//                 }
//             >
//                 <div style={{ height: "calc(100vh - 100px)", overflow: "hidden" }}>
//                     {previewFile?.endsWith(".docx") ? (
//                         <iframe
//                             src={`/edit-document/${id}?agreementFile=${encodeURIComponent(previewFile)}&t=${Date.now()}&editable=false`}
//                             width="100%"
//                             height="100%"
//                             style={{
//                                 border: "none",
//                                 backgroundColor: darkMode ? "#17153B" : "#fff",
//                             }}
//                         />
//                     ) : previewFile?.endsWith(".pdf") ? (
//                         <iframe
//                             src={previewFile}
//                             width="100%"
//                             height="100%"
//                             style={{
//                                 border: "none",
//                                 backgroundColor: darkMode ? "#17153B" : "#fff",
//                             }}
//                         />
//                     ) : null}
//                 </div>
//             </Modal>
//         </>
//     );
// }

// export default EmailThreadItems

// src/components/EmailThread/EmailThreadItem.jsx
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useTheme } from "../../../utils/themeToggle/theme";
import { message } from "antd";
import axiosInstance from "../../../utils/axiosInstance";
import FileGrid from "../../../components/email/FileGrid";
import PreviewModal from "../../../components/modal/PreviewModal";
import { ReplyAllOutlineIcon, ReplyOutlineIcon } from "../../../components/icons/ReplyOutlineIcons";

const EmailThreadItem = ({ item, onReply, id, contract, fetchContracts }) => {
  const [previewFile, setPreviewFile] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAgreementIndex, setSelectedAgreementIndex] = useState(null);
  const [selectedAttachmentIndex, setSelectedAttachmentIndex] = useState(null);
  const [selectedAdditionalIndex, setSelectedAdditionalIndex] = useState(null);
  const [showFull, setShowFull] = useState(false);

  const { darkMode } = useTheme();
  const initials = item?.sender_email?.charAt(0).toUpperCase() || "U";
  const bgColors = ["bg-green-600", "bg-amber-600", "bg-cyan-600", "bg-blue-600"];
  const randomColor = bgColors[(item?.id ?? 0) % bgColors.length];

  const comp_id = useSelector((s) => s.auth.userInfo.company_id);
  const user_id = useSelector((s) => s.auth.userInfo.user_id);
  const companyId = localStorage.getItem("companyId") || comp_id;

  const handlePreview = (fileUrl) => {
    setPreviewFile(fileUrl);
    setIsModalOpen(true);
  };

  const handleSetMainFile = async (fileUrl) => {
    try {
      const payload = { company_id: companyId, file_url: fileUrl };
      const res = await axiosInstance.post(`/agreements/${id}/set-main-file/`, payload);
      const msg = res.data.message || "File set as main agreement successfully!";
      if (res.status === 200) message.success(msg);
      fetchContracts();
    } catch (error) {
      console.error(error);
      const msg = error?.response?.data?.error || "Failed to set file as main agreement";
      message.error(msg);
    }
  };

  return (
    <>
      <div className="flex flex-col gap-1 py-3 border-b border-gray-200 dark:border-gray-700">
        {/* Header */}
        <div className="flex justify-between items-start gap-2">
          <div className="flex gap-2">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center text-white font-medium ${randomColor}`}
            >
              {initials}
            </div>
            <div>
              <div className="flex justify-between items-center gap-5">
                <span className="text-sm font-semibold text-gray-800 dark:text-gray-200">
                  {item.sender_email}
                </span>
                <span className="text-[10px] text-gray-400">
                  {item.timestamp ? new Date(item.timestamp).toLocaleString() : ""}
                </span>
                <span className="text-xs text-gray-600 dark:text-gray-300">
                  {item.direction}
                </span>
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400">
                <div className="block">
                  <strong>To:</strong> {item.receiver_emails?.to?.join(", ") || "-"}
                </div>
                {item.receiver_emails?.cc?.length > 0 && (
                  <div className="block">
                    <strong>CC:</strong> {item.receiver_emails.cc.join(", ")}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="flex gap-2 text-xs">
            <button
              className="text-blue-500 hover:underline"
              onClick={() => onReply(item, "reply")}
            >
              <ReplyOutlineIcon />
            </button>
            <button
              className="text-blue-500 hover:underline"
              onClick={() => onReply(item, "replyAll")}
            >
              <ReplyAllOutlineIcon />
            </button>
          </div>
        </div>

        {/* Message Body */}
        <div className="text-[12px] mt-2 leading-relaxed break-words dark:text-white text-black">
          <div
            className={`relative transition-all duration-300 ${
              showFull ? "line-clamp-none" : "line-clamp-2"
            }`}
            dangerouslySetInnerHTML={{ __html: item.body }}
          />
          {item.body && !showFull && (
            <span
              className="text-blue-500 cursor-pointer text-xs font-medium ml-1"
              onClick={() => setShowFull(true)}
            >
              ... Read more
            </span>
          )}
          {item.body && showFull && (
            <span
              className="text-blue-500 cursor-pointer text-xs font-medium ml-1"
              onClick={() => setShowFull(false)}
            >
              Read less
            </span>
          )}
        </div>

        {/* Files */}
        <FileGrid
          files={item.agreement_file}
          title="Agreement File"
          user_id={user_id}
          contract={contract}
          handleSetMainFile={handleSetMainFile}
          handlePreview={handlePreview}
          selectedIndex={selectedAgreementIndex}
          setSelectedIndex={setSelectedAgreementIndex}
        />
        <FileGrid
          files={item.attachments}
          title="Attachments"
          user_id={user_id}
          contract={contract}
          handleSetMainFile={handleSetMainFile}
          handlePreview={handlePreview}
          selectedIndex={selectedAttachmentIndex}
          setSelectedIndex={setSelectedAttachmentIndex}
        />
        <FileGrid
          files={item.additional_attachments}
          title="Additional Attachments"
          user_id={user_id}
          contract={contract}
          handleSetMainFile={handleSetMainFile}
          handlePreview={handlePreview}
          selectedIndex={selectedAdditionalIndex}
          setSelectedIndex={setSelectedAdditionalIndex}
        />
      </div>

      {/* File Preview Modal */}
      <PreviewModal
        isModalOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        previewFile={previewFile}
        darkMode={darkMode}
        id={id}
      />
    </>
  );
};

export default EmailThreadItem;

